module.exports = __webpack_public_path__ + "d5d5eddf3fbe23bae2e5c11e855ca8b0.svg";